import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { createBrowserHistory } from 'history';

let appInsights: ApplicationInsights | null = null;

export function init() {
  const env = typeof ENV !== 'undefined' ? ENV : window.ENV || {};
  const connectionString = env.APPLICATIONINSIGHTS_CONNECTION_STRING;

  if (!connectionString) {
    console.warn('Application Insights connection string not configured');
    return;
  }

  const browserHistory = createBrowserHistory();
  const reactPlugin = new ReactPlugin();

  appInsights = new ApplicationInsights({
    config: {
      connectionString,
      extensions: [reactPlugin],
      extensionConfig: {
        [reactPlugin.identifier]: {
          history: browserHistory,
        },
      },
      enableAutoRouteTracking: true,
    },
  });

  appInsights.loadAppInsights();
  appInsights.trackPageView();

  return appInsights;
}

export function getAppInsights() {
  return appInsights;
}

export function trackEvent(name: string, properties?: Record<string, unknown>) {
  if (appInsights) {
    appInsights.trackEvent({ name }, properties);
  }
}

export function setUserContext(userId: string, accountId?: string) {
  if (appInsights) {
    appInsights.setAuthenticatedUserContext(userId, accountId, true);
  }
}

export function clearUserContext() {
  if (appInsights) {
    appInsights.clearAuthenticatedUserContext();
  }
}

export function trackFilterUsage(pageContext: string, filters: Record<string, unknown>) {
  if (!appInsights) return;

  const activeFilters: Record<string, unknown> = {};

  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      if (Array.isArray(value)) {
        if (value.length > 0) {
          activeFilters[key] = value;
        }
      } else if (typeof value === 'object') {
        if (Object.keys(value).length > 0) {
          activeFilters[key] = value;
        }
      } else if (value !== '' && value !== false) {
        activeFilters[key] = value;
      }
    }
  });

  if (Object.keys(activeFilters).length > 0) {
    trackEvent('filter_applied', {
      pageContext,
      filters: activeFilters,
      timestamp: new Date().toISOString(),
    });
  }
}
